import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import BasketService from "../services/BasketService";

const useBasketService = () => {
  const { client } = useApiContext();

  const service = useMemo(() => {
    return new BasketService(client);
  }, [client]);

  return service;
};

export default useBasketService;
